export enum DaznChapterData {
    EntitlementSetId = 'entitlementSetId',
    BillingPeriod = 'billingPeriod',
    PromoCode = 'promoCode',
    isFreemium = 'isFreemium',
    Source = 'source',
    isNfl = 'isNfl',
    LwaData = 'LwaData',
    deepLink = 'deepLink',
    errorStatus = 'errorStatus',
    CampaignCode = 'campaignCode',
    GiftCode = 'giftCode',
    freemiumType = 'freemiumType',
    authNflGCJourney = 'authNflGCJourney',
    Type = 'type'
}
